import axios from 'axios'
import { cautionUrl, metricUrl, IhLogUrl, ihConfigUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

// 首页查询告警数量
export function findAlertNum(params) {
  const url = cautionUrl + '/alert/findAlertNum'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '查询告警数量', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询告警类型
export function findAlertType(params) {
  const url = cautionUrl + '/alert/findAlertType'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '查询告警类型', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询在线人数
export function onlinePersons(params) {
  const url = metricUrl + '/device/selectStatus'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '查询在线人数', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询设备列表
export function findDeviceList(params) {
  const url = metricUrl + '/device/findDeviceList'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '查询设备列表', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询设备序列号
export function findDeviceNames(params) {
  const url = metricUrl + '/device/findDeviceNames'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '查询所有设备序列号', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询未处理告警信息
export function findMsgByDeviceName(params) {
  const url = cautionUrl + '/alert/findMsgByDeviceName'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '查询未处理告警信息', res)
    }
    return Promise.resolve(res.data)
  })
}

// 修改告警状态
export function updateStatus(params) {
  const url = cautionUrl + '/alert/updateStatus'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '修改告警状态', res)
    }
    return Promise.resolve(res.data)
  })
}

export function selectRecord(params) {
  const url = metricUrl + '/universal/selectRecord'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '查询设备最后信息', res)
    }
    return Promise.resolve(res.data)
  })
}

// jls位置信息查询
export function locationRecord(params) {
  const url = metricUrl + '/location/selectRecord'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '帽衬设备位置信息查询', res)
    }
    return Promise.resolve(res.data)
  })
}

// gk3位置信息查询
export function gpsRecord(params) {
  const url = IhLogUrl + '/gps/find/' + params

  return axios({
    method: 'get',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '安卓设备位置信息查询', res)
    }
    return Promise.resolve(res.data)
  })
}

// jls轨迹列表查询
export function trailGroup(params) {
  const url = metricUrl + '/device/gps/group/page'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '帽衬设备轨迹列表查询', res)
    }
    return Promise.resolve(res.data)
  })
}

// jls设备位置时段信息查询
export function traceLocation(params) {
  const url = metricUrl + '/location/trace'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '帽衬设备位置时段信息查询', res)
    }
    return Promise.resolve(res.data)
  })
}
// 获取变电站信息
export function getStationlist() {
  const url = ihConfigUrl + '/map/point/find/message'
  return axios({
    method: 'get',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '查询帽衬设备gps轨迹详情', res)
    }
    return Promise.resolve(res.data)
  })
}

export function healthRecord(params) {
  const url = IhLogUrl + '/extra/vital/signs'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '查询IH6设备生命体征信息', res)
    }
    return Promise.resolve(res.data)
  })
}
